import { useMemo } from 'react';
import { Calendar } from '@belong/ui';

type CalendarFormAdapterProps = {
  // react-final-form's field bag; it is untyped JS all the way down and the
  // spread below hands it straight to `Calendar`.
  input: any;
  meta?: { error?: unknown };
  ignoreError?: boolean;
  onChangeCustom?: (...args: unknown[]) => void;
  // Stands for the props `...rest` forwards to `Calendar`.
  [key: string]: unknown;
};

export function CalendarFormAdapter({
  input,
  meta,
  ignoreError,
  onChangeCustom,
  ...rest
}: CalendarFormAdapterProps) {
  const selectedDay = useMemo(() => input.value, [input.value]);

  return (
    <div className="relative ml-0 flex flex-wrap sm:-ml-lg md:flex-nowrap lg:flex-wrap xl:flex-nowrap">
      <Calendar
        {...input}
        {...rest}
        error={!ignoreError ? meta!.error : false}
        selected={selectedDay}
        onSelect={(key: Date | undefined, object?: unknown) => {
          input.onChange(key, object);

          if (onChangeCustom) {
            onChangeCustom(key, object);
          }
        }}
      />
    </div>
  );
}
